module.exports = __webpack_public_path__ + "img/Profile.aabe404b.svg";